import { render, staticRenderFns } from "./Cultivos.vue?vue&type=template&id=464de34d&scoped=true"
import script from "./Cultivos.vue?vue&type=script&lang=js"
export * from "./Cultivos.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Cultivos.vue?vue&type=style&index=1&id=464de34d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464de34d",
  null
  
)

export default component.exports